import { render, staticRenderFns } from "./ActionItemsList.vue?vue&type=template&id=21fdcaf6&scoped=true"
import script from "./ActionItemsList.vue?vue&type=script&lang=js"
export * from "./ActionItemsList.vue?vue&type=script&lang=js"
import style0 from "./ActionItemsList.vue?vue&type=style&index=0&id=21fdcaf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fdcaf6",
  null
  
)

export default component.exports